import { render, staticRenderFns } from "./ChainReport.vue?vue&type=template&id=72cf2e20&scoped=true"
import script from "./ChainReport.vue?vue&type=script&lang=js"
export * from "./ChainReport.vue?vue&type=script&lang=js"
import style0 from "./ChainReport.vue?vue&type=style&index=0&id=72cf2e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf2e20",
  null
  
)

export default component.exports